import React from "react";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-page">
      <section className="banner-section">
        <div className="intro">
          <div className="intro-bg wow fadeIn" data-wow-delay="0.5s">
            <img
              src="/assets/images/background/intro-bg.jpg"
              alt="Light Background"
            />
          </div>
          <div className="container wow fadeInUp" data-wow-delay="0.5s">
            <h1>Privacy Policy</h1>
          </div>
        </div>
      </section>

      <section className="sub-section">
        <div className="container">
          <div className="title-small wow fadeInUp">
            <span>Privacy Policy</span>
          </div>
          <div className="title row wow fadeInUp custom-px">
            <div>
              <p className="company-url">
                <Link to="/" style={{ color: "blue", textDecoration: "underline" }}>
                  slashstar.co
                </Link>{" "}
                is a wholly owned subsidiary of XR Studio LLP.
              </p>
              <p>
                We, at Slash Star, are committed to protecting the privacy of our visitors,
                for we do not spam, sell, rent, lease or give away the information to any third party/parties.
              </p>
              <p>
                It is projected to describe how we use and process your personal information. Please ensure that
                by
                visiting and using slashstar.co, you are agreeing to and accepting the policies that are
                described in this Privacy Policy.
              </p>
              <p>
                This Privacy Policy also explains how we are going to use your personal information and what
                happens to any personal data
                that you provide to us. Moreover, we do update the policies of this page from time to time, so
                please keep reviewing the page on a
                regular basis.
              </p>

              <h4>Information We Collect:</h4>
              <h4>(i) Personal Information</h4>
              <p>
                The personal information that we may collect includes your name, contact information, IP
                addresses, product and service selections,
                and other information, identifying you. We may also gather and collect personal information from
                you at different points,
                including but not limited to the following:
              </p>

              <h4>(ii) Non-personal Data</h4>
              <p>
                We may also collect or gather non-personal data or information about users whenever they prefer
                to interact with our website.
                Non-personal data and information include the browser name that the user access, the type of
                computer, technical information
                like operating system and Internet service providers, and other similar information via Google
                Analytics.
              </p>

              <ul>
                <li>At the time of communicating with you as a customer or prospective customer;</li>
                <li>When you prefer to visit our website or make use of the platform;</li>
                <li>
                  While registering you as an end-user of our products or services and one account is
                  specially made for you;
                </li>
                <li>When you fill out our "Contact Us" form to get in touch with our experts;</li>
              </ul>

              <h4>Cookies:</h4>
              <p>
                Our website does not collect any information about users, except for the information contained in
                Cookies.
                Talking about cookies, they are small text files, which are mainly saved and retrieved
                information about your
                visit to our website. We use cookies to give a personalized experience on our website. Here, you
                can find how we use cookies:
              </p>
              <ul>
                <li>
                  <strong>Session cookies:</strong> generally, session cookies are cached mainly for the
                  duration of your use of our website;
                </li>
                <li>
                  <strong>Permanent cookies:</strong> permanent cookies are stored in your terminal device for
                  the time specified in the Cookie files parameters or until you delete them.
                </li>
              </ul>
              <p>You can adjust the settings on your computer in order to decline any cookies if you wish to.</p>

              <h4>Disclosing Your Information:</h4>
              <p>
                We assure you that we will not disclose your gathered personal information to any other party
                than in
                agreement with this Privacy Policy. Some of the circumstances given below when we may need to
                share your share:
              </p>
              <ul>
                <li>In any situation, when we might have to sell any or all of our business to the buyer.</li>
                <li>We may disclose your personal information when it is legally required by the law.</li>
                <li>To protect fraud and reduce the risk of fraud.</li>
              </ul>
              <p>
                Slash Star never sells, trades, or rents users personal information to others. If required, we
                may share general demographic data and information
                that is not linked to any personal information regarding visitors with our trusted business
                partners, affiliates, and advertisers for the purpose mentioned above.
              </p>

              <h4>Security:</h4>
              <p>
                Here, we make sure that your shared personal or non-personal information is safe and secure from
                any unauthorized access, use, loss, or destruction.
                Personal or non-personal information provided by you is stored on a safe and secured web server
                that is managed by Slash Star.
                To protect from authorized access, we have used physical, electronic, and managerial procedures
                to safeguard and secure the information.
              </p>

              <h4>Third-Party Websites:</h4>
              <p>
                Regarding the links to other sites, Slash Star is not responsible for the privacy practices or
                the content of such websites. This Privacy/Security
                statement does not apply to any third-party websites that are linked to this website. Even
                third-party logos, brands & names used on this website
                are the property of their respective owners. Slash Star will not share your personal information
                with third parties for marketing purposes, without your prior consent.
              </p>
              <p>
                We may provide links to third-party websites and services. However, we are not responsible for
                the privacy statements, practices, or the contents of such third-party websites.
              </p>

              <h4>Changes to Privacy Policy:</h4>
              <p>
                Slash Star reserves the right to change, edit or amend this Privacy Policy at any time without
                any prior notice.
                When we change, edit or remove any part from this privacy policy, we will mention the updated
                date at the bottom of this privacy policy
                page. We encourage our users to keep reviewing this page frequently in order to stay updated
                with the changes that we
                perform. The continuing use of our website means that you agree and accept those changes.
              </p>

              <h4>Data Breach:</h4>
              <p>
                In case of any data breach of personal information/websites database / third-party data,
                processors are apparent,
                we will, within 72 hours, inform all relevant authorities about the same.
              </p>

              <h4>Termination:</h4>
              <p>
                Slash Star reserves the right, in its sole discretion, to restrict or terminate the availability
                of the Site to any
                other person, geographic area, or jurisdiction at any time. No notice is required to effect any
                such restriction or termination.
              </p>

              <h4>Contact Us:</h4>
              <p>
                In case, if you have any query or question regarding our Privacy Policy, you can get in touch
                with us using the Contact us form.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
